import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// material-ui
import ButtonBase from "@mui/material/ButtonBase";

// project-imports
import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";
import useAuth from "hooks/useAuth";
import { APP_DEFAULT_PATH } from "config";

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({
  isIcon,
  sx,
  to,
  dark,
  height,
  maxWidth,
}) {
  const { isLoggedIn } = useAuth();

  return (
    <ButtonBase
      disableRipple
      {...(isLoggedIn && {
        component: Link,
        to: !to ? APP_DEFAULT_PATH : to,
        sx,
      })}
    >
      {isIcon ? (
        <LogoIcon dark={dark} />
      ) : (
        <Logo dark={dark} height={height} maxWidth={maxWidth} />
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  isIcon: PropTypes.bool,
  sx: PropTypes.any,
  to: PropTypes.any,
  dark: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
